<template>
    <q-modal
      v-model="scheduleUploadOpen"
      class="sl-modal"
      id="schedule-upload"
      :content-css="{minWidth: '30vw'}"
      :no-esc-dismiss="true"
      :no-backdrop-dismiss="true"
    >
      <q-modal-layout>
        <q-toolbar slot="header">
          <q-icon name="playlist add check"></q-icon>
          <q-toolbar-title>
            Schedule Uploads
          </q-toolbar-title>
          <q-icon @click.native="onClose" name="clear" :disabled="processingSchedule" />
        </q-toolbar>

        <div id="upload-body" class="layout-padding" v-if="!scheduleProcessed">
          <div>
            <span>You can upload your class schedules using this <i class="fa fa-file-excel-o" style="font-size: 28px;vertical-align: middle;"></i> <a href="statics\examples\Schedule- format.xlsx" target="_blank">format</a>.<br> You must provide the instructor code for a valid import.</span>
          </div>
          <div class="q-pt-xl q-px-sm">
            <h6> Select File.. </h6>
            <q-field
              helper="Accepts Microsoft Excel Documents (.xlsx, .xls)"
              class="q-pa-sm"
              >
              <q-uploader 
                auto-expand
                ref="scheduleUpload"
                hide-upload-button
                url=""
                :url-factory="uploadFile"
                extensions=".xlsx,.xls"
                @finish="onFinish"
              />
            </q-field>
          </div>
        </div>
        <div class="" v-if="scheduleProcessed">
          <Grid
            v-if="processedRows.length > 0"
            selectable="multiple"
            :columns="columnOptions"
            :data="processedRows"
            :visibleColumns="visibleColumns"
            :hideShowColumns="true"
            :exceptionMap="scheduleUploadExceptionMap"
            :selected="selectedScheduleProcessRows"
            :pagination="paginationOptions"
            :onSelect="updateSelectedProcessedRows"
            hide-footer
          >
            <template slot="col-item-affiliate" slot-scope="props">
              <span v-if="processedRows[props.index].AFFILIATE">
                {{processedRows[props.index].AFFILIATE.AFFILIATE_NAME}} - ({{processedRows[props.index].AFFILIATE.AFFILIATE_CODE}})
              </span>
              <span v-if="!processedRows[props.index].AFFILIATE">
                Not Valid Affiliate
                <q-icon name="help" color="red" size="17px" style="vertical-align:middle">
                  <q-tooltip anchor="top middle"
                            self="bottom middle"
                            class="red"
                            :offset="[10, 10]">
                            <h6 style="font-size:18px;">Possible Reasons</h6>
                            Affiliate may be inactive.<br>
                            Affiliate code was empty.<br>
                            You may not have access to the Affiliate.
                  </q-tooltip>
                </q-icon>
              </span>
            </template>

            <template slot="col-item-date" slot-scope="props">
              {{ moment.utc(props.value).format("MMMM Do, YYYY") }}
              <span v-if="processedRows[props.index].BAD_START_DATE">
                <q-icon name="help" color="red" size="17px" style="vertical-align:middle">
                  <q-tooltip anchor="top middle"
                            self="bottom middle"
                            class="red"
                            :offset="[10, 10]">
                            <h6 style="font-size:18px;">Date must be at least 30 days out</h6>
                  </q-tooltip>
                </q-icon>
              </span>
            </template>

            <template slot="col-item-instructor" slot-scope="props">
              <span v-if="processedRows[props.index].INSTRUCTOR">
                {{processedRows[props.index].INSTRUCTOR.USER.USER_FIRST_NAME + ' ' +  processedRows[props.index].INSTRUCTOR.USER.USER_LAST_NAME}}
              </span>
              <span v-if="!processedRows[props.index].INSTRUCTOR">
                Not Valid Instructor
                <q-icon name="help" color="red" size="17px" style="vertical-align:middle">
                  <q-tooltip anchor="top middle"
                            self="bottom middle"
                            class="red"
                            :offset="[10, 10]">
                            <h6 style="font-size:18px;">Possible Reasons</h6>
                            Instructor may not belong to Affiliate.<br>
                            Instructor may be inactive.<br>
                            Instructor may not be approved.<br>
                            Instructor code was empty.
                  </q-tooltip>
                </q-icon>
              </span>
            </template>
          </Grid>
          <div v-if="processedRows.length == 0" class="q-pa-xl text-center">
            <q-icon name="search" color="grey-5" size="60px" /><br>
            No records to import
          </div>
        </div>        
        <q-toolbar slot="footer">
          <q-btn outline color="faded" @click.native="resetScheduleUpload" :disabled="processingSchedule" v-if="scheduleProcessed" label="Reset" icon="refresh" />&nbsp;
          <q-btn outline color="red" @click.native="removeSelectedProcessedRows" v-if="selectedScheduleProcessRows.length > 0 && scheduleProcessed && !processingSchedule" label="Remove Selected" />
          <q-toolbar-title>
          </q-toolbar-title>
          <span v-if="scheduleProcessed && !validRows" class="text-red" style="margin-right: 3px;vertical-align:middle; font-size:13px;">
            <q-icon name="error" color="red" size="20px" /> Please remove invalid rows!
          </span>
          <q-btn label="Upload" color="green" @click="upload()" v-if="!scheduleProcessed" :disabled="processingSchedule" />&nbsp;
          <q-btn label="Finalize" color="green" @click.native="finalizeUploadMethod" v-if="scheduleProcessed" :disabled="!validRows || processedRows.length == 0 || processingSchedule" icon="cloud_upload" />&nbsp;
          <q-btn outline color="faded" @click.native="onClose" :disabled="processingSchedule" label="Cancel" />          
        </q-toolbar>
      </q-modal-layout>
      <q-inner-loading :visible="processingSchedule">
          <q-spinner-gears color="primary" size="70"></q-spinner-gears>
          <span>Processing</span>
      </q-inner-loading>
    </q-modal>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import Grid from "../Shared/Grid"
const moment = require('moment')

export default {
  name: 'ScheduleUploadDialog',
  mounted () {
  },
  components: {
    Grid
  },
  data () {
    return {
      visibleColumns: ['AFFILIATE', 'INSTRUCTOR', 'DATE', 'START_TIME', 'END_TIME', 'LOCATION_ADDRESS', 'CITY', 'STATE', 'COUNTY_CODE', 'ZIP_CODE', 'DATE2', 'START_TIME2', 'END_TIME2'],
      columnOptions: [
        { field: 'AFFILIATE', name: 'AFFILIATE', label: 'Affiliate', sortable: false, type: 'string', exception: false,
          format: r => `${r.AFFILIATE_NAME} - (${r.AFFILIATE_CODE})`
        },
        { field: 'INSTRUCTOR', name: 'INSTRUCTOR', label: 'Instructor', sortable: false, type: 'string', exception: true,
          format: r => {
            return r ? `${r.USER.USER_FIRST_NAME} ${r.USER.USER_LAST_NAME}` : `Instructor Not Valid.`
          }
        },
        { field: 'DATE', name: 'DATE', label: 'Date', sortable: false, type: 'string', exception: false },
        { field: 'START_TIME', name: 'START_TIME', label: 'Start Time', sortable: false, type: 'string', exception: false },
        { field: 'END_TIME', name: 'END_TIME', label: 'End Time', sortable: false, type: 'string', exception: false },
        { field: 'LOCATION_ADDRESS', name: 'LOCATION_ADDRESS', label: 'Address', sortable: false, type: 'string', exception: false },
        { field: 'CITY', name: 'CITY', label: 'City', sortable: false, type: 'string', exception: false },
        { field: 'STATE', name: 'STATE', label: 'State', sortable: false, type: 'string', exception: false },
        { field: 'COUNTY_CODE', name: 'COUNTY_CODE', label: 'County', sortable: false, type: 'string', exception: false },
        { field: 'ZIP_CODE', name: 'ZIP_CODE', label: 'Zip', sortable: false, type: 'string', exception: false },
        { field: 'DATE2', name: 'DATE2', label: 'Date (2)', sortable: false, type: 'string', exception: false },
        { field: 'START_TIME2', name: 'START_TIME2', label: 'Start Time (2)', sortable: false, type: 'string', exception: false },
        { field: 'END_TIME2', name: 'END_TIME2', label: 'End Time (2)', sortable: false, type: 'string', exception: false }

      ],
      moment: moment,
      paginationOptions: {
        rowsPerPage: 0,
        page:1
      }
    }
  },
  validations(){
    return {
      
    }
  },
  computed: {
    ...mapState('classes', {
      scheduleUploadOpen: (state) => state.scheduleUploadOpen,
      processingSchedule: s => s.processingSchedule,
      processedRows: s => s.processedRows,
      scheduleProcessed : s => s.scheduleProcessed,
      selectedScheduleProcessRows: s => s.selectedScheduleProcessRows,
    }),
    ...mapState('documents', {
      uploadForm: (state) => state.uploadForm
    }),
    ...mapGetters('classes',[
      'scheduleUploadExceptionMap'
    ]),
    validRows(){
      return _.every(this.processedRows, pr => !pr.exception)
    }
  },
  methods: {
    ...mapMutations('classes', [
      'setScheduleUploadOpen',
      'resetScheduleUpload',
      'updateSelectedProcessedRows',
      'removeSelectedProcessedRows'
    ]),
    ...mapActions('classes', [
      'processSchedule',
      'finalizeUpload'
    ]),
    upload () {
      this.$refs.scheduleUpload.upload()
    },
    uploadFile(file, updateProgress){
      this.processSchedule(file)
    },
    onClose () {
      this.setScheduleUploadOpen(false)
    },
    finalizeUploadMethod() {
      this.finalizeUpload({vm: this})
    }
  }
}
</script>

<style lang="stylus">
#upload-body
  overflow-y: auto
#schedule-upload
  .q-table-top
    display none
  tbody
    tr
      background-color:#c9ffc9 !important
      &:hover,
      &.selected
        background-color #b6ecff !important
      &.exception
        background-color:#ffc6c6  !important
        &:hover,
        &.selected
          background-color:#d9c6ff !important
</style>
